/* Leguntable · estilo Bold Bean — comportamiento de las secciones lg-* */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const raiz = () => window.Shopify?.routes?.root || '/';
  const money = cents => '$' + Math.round(cents / 100).toLocaleString('es-CL');

  /* Menú del celular */
  function menuMovil(btn) {
    const panel = $('[data-lg-movil]');
    if (!panel) return;
    btn.addEventListener('click', () => {
      const abierto = !panel.hidden;
      panel.hidden = abierto;
      btn.setAttribute('aria-expanded', String(!abierto));
    });
  }

  /* Arma tu caja: se elige el tamaño (ej. 3 o 6), se llenan los casilleros y se agregan todos juntos al carro */
  function armaCaja(root) {
    let total = Number(root.dataset.tamano || 6);
    let dcto = Number(root.dataset.dcto || 0);
    const slots = $$('[data-lg-slot]', root);
    const cuenta = $('[data-lg-cuenta]', root);
    const sumaEl = $('[data-lg-suma]', root);
    const btn = $('[data-lg-agregar]', root);
    const err = $('[data-lg-error]', root);
    const tamanos = $$('[data-lg-tamano]', root);
    const elegidos = [];

    const pintar = () => {
      slots.forEach((slot, i) => {
        const e = elegidos[i];
        slot.hidden = i >= total;
        slot.classList.toggle('is-lleno', !!e);
        slot.innerHTML = e ? `<img src="${e.img}" alt="${e.nombre}" loading="lazy">` : '<span>?</span>';
        slot.setAttribute('aria-label', e ? `Quitar ${e.nombre}` : `Espacio ${i + 1} vacío`);
      });
      cuenta.textContent = `${elegidos.length} de ${total}`;
      const suma = elegidos.reduce((a, e) => a + e.precio, 0);
      sumaEl.textContent = money(suma) + (dcto && elegidos.length === total ? ` · −${dcto}% en el carro` : '');
      btn.disabled = elegidos.length !== total;
    };

    // Cambiar de caja: si se pasa de 6 a 3 se quedan los 3 primeros frascos elegidos
    tamanos.forEach(b => b.addEventListener('click', () => {
      total = Number(b.dataset.lgTamano);
      dcto = Number(b.dataset.dcto || 0);
      tamanos.forEach(x => { x.classList.toggle('is-activo', x === b); x.setAttribute('aria-checked', String(x === b)); });
      elegidos.splice(total);
      err.hidden = true;
      pintar();
    }));

    $$('[data-lg-sabor]', root).forEach(b => b.addEventListener('click', () => {
      if (elegidos.length >= total) return;
      elegidos.push({ id: b.dataset.id, img: b.dataset.img, nombre: b.dataset.nombre, precio: Number(b.dataset.precio) });
      pintar();
    }));
    slots.forEach((slot, i) => slot.addEventListener('click', () => {
      if (!elegidos[i]) return;
      elegidos.splice(i, 1);
      pintar();
    }));
    btn.addEventListener('click', async () => {
      err.hidden = true;
      const porId = {};
      elegidos.forEach(e => { porId[e.id] = (porId[e.id] || 0) + 1; });
      btn.disabled = true;
      try {
        const r = await fetch(`${raiz()}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: Object.entries(porId).map(([id, quantity]) => ({ id: Number(id), quantity })) }),
        });
        if (!r.ok) throw new Error((await r.json()).description || 'No se pudo agregar al carro');
        window.location.href = `${raiz()}cart`;
      } catch (e) {
        err.textContent = e.message;
        err.hidden = false;
        btn.disabled = false;
      }
    });
    pintar();
  }

  /* Galería de la ficha */
  function galeria(root) {
    const main = $('[data-lg-main] img', root);
    const thumbs = $$('[data-lg-thumb]', root);
    thumbs.forEach(b => b.addEventListener('click', () => {
      thumbs.forEach(x => x.classList.toggle('is-activo', x === b));
      main.srcset = b.dataset.srcset || '';
      main.src = b.dataset.src;
      main.alt = b.dataset.alt || main.alt;
    }));
  }

  /* Cantidad +/- (la barra de abajo no tiene cantidad propia: envía el formulario de la ficha) */
  function cantidad(w) {
    const inp = $('input', w);
    $$('button', w).forEach(b => b.addEventListener('click', () => {
      inp.value = Math.max(1, (Number(inp.value) || 1) + Number(b.dataset.paso));
    }));
  }

  /* Barra fija de compra: aparece cuando el botón principal ya quedó arriba de la pantalla */
  function barra(bar) {
    const ancla = $('[data-lg-compra]');
    if (!ancla || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([e]) => {
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(ancla);
  }

  /* Flechas de carruseles */
  function flechas(sec) {
    const track = $('[data-lg-track]', sec);
    if (!track) return;
    $$('[data-lg-dir]', sec).forEach(b => b.addEventListener('click', () => {
      track.scrollBy({ left: Number(b.dataset.lgDir) * track.clientWidth * 0.8, behavior: 'smooth' });
    }));
  }

  /* Pestañas de la receta */
  function tabs(w) {
    const btns = $$('[data-lg-tab]', w);
    btns.forEach(b => b.addEventListener('click', () => {
      btns.forEach(x => { x.classList.toggle('is-activo', x === b); x.setAttribute('aria-selected', String(x === b)); });
      $$('[data-lg-panel]', w).forEach(p => { p.hidden = p.dataset.lgPanel !== b.dataset.lgTab; });
    }));
  }

  // Cada función corre una sola vez por elemento: el editor de temas vuelve a llamar init al recargar una sección.
  const una = (sel, fn) => $$(sel).forEach(el => { if (el.dataset.lgOk) return; el.dataset.lgOk = '1'; fn(el); });
  const init = () => {
    una('[data-lg-burger]', menuMovil);
    una('[data-lg-caja]', armaCaja);
    una('[data-lg-galeria]', galeria);
    una('[data-lg-cant]', cantidad);
    una('[data-lg-barra]', barra);
    una('[data-lg-carrusel]', flechas);
    una('[data-lg-tabs]', tabs);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
